import { api } from "@services/api"
import { sendPushNotificationService } from "./native-service"

export const nativeApi = api.injectEndpoints({
  endpoints: (build) => ({
    //send push notifications
    sendPushNotification: build.mutation({
      queryFn: async (body) => {
        const result: any = await new Promise((resolve) =>
          sendPushNotificationService(body)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )
        return { data: result, error: result.error }
      },
      invalidatesTags: [],
    }),
  }),
})

export const { useSendPushNotificationMutation } = nativeApi
